/**
 * Apelido de exibição dos bots — derivação CLIENT-SIDE sobre os vínculos que a tela
 * já busca (`GET /dependencias/bots`), sem mexer nos payloads agregados.
 *
 * Regra (pedido 04/09: "renomear sem alterar o nome real"): o apelido é SÓ exibição.
 * Chaves, ids, filtros, queryKeys e navegação continuam pelo NOME REAL do bot; todo
 * lugar que MOSTRA nome de bot resolve por aqui, com fallback para o nome real quando
 * não há apelido — e o nome real vai para o title/tooltip quando o apelido aparece.
 */

import type { IVinculoBot } from '../api';

export type MapaApelidos = ReadonlyMap<string, string>;

/**
 * Mapa nome real → apelido. Apelido nulo/vazio/só-espaços fica FORA do mapa — assim
 * `exibirBot` cai no nome real e `temApelido` responde false (sem tooltip redundante).
 */
export const mapaDeApelidos = (
  vinculos: Array<Pick<IVinculoBot, 'bot' | 'apelido'>>,
): MapaApelidos =>
  new Map(
    vinculos
      .filter(v => Boolean(v.apelido && v.apelido.trim()))
      .map(v => [v.bot, (v.apelido as string).trim()]),
  );

/** Nome exibível do bot: apelido quando houver, senão o nome real. */
export const exibirBot = (mapa: MapaApelidos, bot: string): string => mapa.get(bot) ?? bot;
